module.exports = __webpack_public_path__ + "img/settings.350803ee.svg";